import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import {
  RanchPageViewEnum,
  selectRanchPageView,
  setRanchFocusArea,
  setRanchPageView,
} from '../../../ranches/ranchesSlice';
import {
  ResetItemsEnum,
  resetSelectFields,
  setCurrBlockByID,
} from '../../../select/selectSlice';
import { LogoExpandable } from '../LogoExpandable';

/**
 * Button to navigate to Ranch summary using the expandable logo
 * If clicked in block detail view, it returns to ranch view
 */
type LogoExpandableNavButtonProps = {
  isExpanded: boolean;
};

export const LogoExpandableNavButton = ({
  isExpanded,
}: LogoExpandableNavButtonProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const ranchPageView = useAppSelector(selectRanchPageView);
  const dispatch = useAppDispatch();

  const handleLogoClick = () => {
    if (location.pathname !== '/') {
      navigate('/');
    }
    if (ranchPageView !== RanchPageViewEnum.ranchSummary) {
      dispatch(
        resetSelectFields([
          ResetItemsEnum.Scan,
          ResetItemsEnum.AllCubeRelatedFields,
        ])
      );
      dispatch(setCurrBlockByID(''));
      dispatch(setRanchPageView(RanchPageViewEnum.ranchSummary));
      dispatch(setRanchFocusArea(null));
    }
  };

  return <LogoExpandable open={isExpanded} onClick={handleLogoClick} />;
};
